$(".awardslider").slick({
   slidesToShow: 6,
   infinite:false,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
   arrows: true,
   prevArrow: '<button class="slide-arrow prev-arrow"></button>',
   nextArrow: '<button class="slide-arrow next-arrow"></button>',
   responsive: [
       {
      breakpoint: 767,
      settings: {
         slidesToShow: 4,
      },
    },
     ]
 
  });



// Tab 
// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});


// Product Slider 
 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.slider-nav',
    prevArrow: '<button class="slide-arrow prev-arrow"><img alt="prev icon" src="https://klhaudiodirect.myshopify.com/cdn/shop/t/1/assets/prevv.png"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><img alt="next icon" src="https://klhaudiodirect.myshopify.com/cdn/shop/t/1/assets/nexttt.png"></button>',
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  arrows: false,
  loop: true,
  centerMode: false,
  focusOnSelect: true
});



 $(".reviewSlider").slick({
     slidesToShow: 1,
     infinite:false,
     slidesToScroll: 1,
     autoplay: false,
     autoplaySpeed: 2000,
     arrows: true,
     dots: true,
     responsive: [
       {
      breakpoint: 767,
      settings: {
        dots: true
      },
    },
     ]
  });







